module.exports = __webpack_public_path__ + "static/media/cloud_off_black.e9ef1086.svg";